import React, { lazy, Suspense } from 'react';

// Lazy load the actual model implementation
// Import the original component to avoid circular dependencies
const LazyPokoModel = lazy(() => import('./PokoModel'));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px'
  }}>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

/**
 * PokoViewer - Entry point component that lazy loads the actual 3D model
 * This helps improve initial page load time by deferring model loading
 */
const PokoViewer = (props) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <LazyPokoModel config={props.config} />
    </Suspense>
  );
};

export default PokoViewer; 